import { render, staticRenderFns } from "./CertificateSearch.vue?vue&type=template&id=100d6a64"
import script from "./CertificateSearch.vue?vue&type=script&lang=js"
export * from "./CertificateSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports